import React, { useState } from 'react';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import styles from './Pagination.module.scss';

const Pagination = ({
  currentPage,
  totalPages,
  totalRecords,
  pageSize,
  onPageChange,
  onPageSizeChange,
  showPageSizeSelector = true,
  showRecordsInfo = true
}) => {
  // Simple pagination - only show next/previous
  const [lastClicked, setLastClicked] = useState(null); // Track which button was last clicked
  
  const startRecord = (currentPage - 1) * pageSize + 1;
  const endRecord = Math.min(currentPage * pageSize, totalRecords);

  const handlePageChange = (page, buttonType) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      setLastClicked(buttonType); // Track which button was clicked
      onPageChange(page);
      
      // Reset the clicked state after a short delay
      setTimeout(() => {
        setLastClicked(null);
      }, 1000);
    }
  };

  const handlePageSizeChange = (newSize) => {
    onPageSizeChange(parseInt(newSize));
  };

  if (totalPages <= 1) {
    return null; // Don't show pagination if there's only one page or no pages
  }

  return (
    <div className={styles.paginationContainer}>
      {showRecordsInfo && (
        <div className={styles.recordsInfo}>
          Showing {startRecord} to {endRecord} of {totalRecords} records
        </div>
      )}
      
      <div className={styles.paginationControls}>
        {/* Previous Button */}
        <button
          className={`${styles.pageButton} ${currentPage === 1 ? styles.disabled : ''} ${lastClicked === 'previous' ? styles.clicked : ''}`}
          onClick={() => handlePageChange(currentPage - 1, 'previous')}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          <BsChevronLeft size={16} />
          <span>Previous</span>
        </button>

        {/* Next Button */}
        <button
          className={`${styles.pageButton} ${currentPage === totalPages ? styles.disabled : ''} ${lastClicked === 'next' ? styles.clicked : ''}`}
          onClick={() => handlePageChange(currentPage + 1, 'next')}
          disabled={currentPage === totalPages}
          aria-label="Next page"
        >
          <span>Next</span>
          <BsChevronRight size={16} />
        </button>
      </div>

      {showPageSizeSelector && (
        <div className={styles.pageSizeSelector}>
          <label htmlFor="pageSize">Show:</label>
          <select
            id="pageSize"
            value={pageSize}
            onChange={(e) => handlePageSizeChange(e.target.value)}
            className={styles.pageSizeSelect}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span>per page</span>
        </div>
      )}
    </div>
  );
};

export default Pagination;
